module.exports = __webpack_public_path__ + "img/Jump Casting83.c5509412.jpg";